import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  approvePaymentList: { loading: false, data: null, error: null },
  changePaymentStatus: { loading: false, data: null, error: null },
};

export const ApprovePaymentSlice = createSlice({
  name: "approvePayment",
  initialState,
  reducers: {
    fetchapprovePaymentListRequest: (state, action) => {
      state.approvePaymentList.loading = true;
      state.approvePaymentList.error = null;
    },
    fetchapprovePaymentListSuccess: (state, action) => {
      state.approvePaymentList.data = action.payload;
      state.approvePaymentList.loading = false;
      state.approvePaymentList.error = null;
    },
    fetchapprovePaymentListFailure: (state, action) => {
      state.approvePaymentList.data = null;
      state.approvePaymentList.loading = false;
      state.approvePaymentList.error = action.payload;
    },

    changePaymentStatusRequest: (state, action) => {
      state.changePaymentStatus.loading = true;
      state.changePaymentStatus.error = null;
    },
    changePaymentStatusSuccess: (state, action) => {
      state.changePaymentStatus.data = action.payload;
      state.changePaymentStatus.loading = false;
      state.changePaymentStatus.error = null;
      // state.approvePaymentList = editRecord(action.payload, {
      //   ...state.approvePaymentList,
      // });
    },
    changePaymentStatusFailure: (state, action) => {
      state.changePaymentStatus.data = null;
      state.changePaymentStatus.loading = false;
      state.changePaymentStatus.error = action.payload;
    },
    resetChangePaymentStatus: (state, action) => {
      state.changePaymentStatus.data = null;
      state.changePaymentStatus.loading = false;
      state.changePaymentStatus.error = null;
    },
  },
});

function editRecord(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}

export const {
  fetchapprovePaymentListRequest,
  fetchapprovePaymentListSuccess,
  fetchapprovePaymentListFailure,

  changePaymentStatusRequest,
  changePaymentStatusSuccess,
  changePaymentStatusFailure,
  resetChangePaymentStatus,
} = ApprovePaymentSlice.actions;

export const getApprovePaymentListState = (store) =>
  store.approvePayment?.approvePaymentList;

export const getApprovePaymentStatusState = (store) =>
  store.approvePayment?.changePaymentStatus;
export default ApprovePaymentSlice.reducer;
